<template>
  <v-dialog v-model="dialog" fullscreen persistent scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon color="white" @click="cancel" class="mr-4">mdi-arrow-left</v-icon>
        <v-toolbar-title>XẾP THỜI KHÓA BIỂU</v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-card outlined class="pa-4 my-4 elevation-0">
          <v-row>
            <v-col cols="12" md="6">
              <AutocompleteClass
                v-model="classData"
                clear-icon="mdi-close"
                placeholder="Lớp"
                outlined
                dense
                large
                deletable-chips
                hide-details
              />
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex justify-end">
                <v-btn
                  class="search-button"
                  color="#0D47A1"
                  @click="onFilterChanged"
                  outlined
                  :disabled="!classData || !classData.id"
                >
                  Chọn xếp
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <div class="d-flex justify-center">
          <div :style="{ width: '1024px' }">
            <SetupTimeTableForClass ref="time-table" :classProp="classData" v-show="isEnable" />
          </div>
        </div>
      </v-card-text>
      <v-divider v-if="searchClass"></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="!searchClass" depressed color="primary" class="ma-2 mr-2 white--text" @click="save"
          >Lưu thời khóa biểu</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import get from 'lodash-es/get'
import SetupTimeTableForClass from './SetupTimeTableForClass.vue'

export default {
  components: {
    AutocompleteClass,
    SetupTimeTableForClass,
  },
  props: {
    state: Boolean,
  },
  data() {
    return {
      dialog: false,
      classData: null,
      over: false,
      searchClass: false,
      windowHeight: window.innerHeight,
      isEnable: false,
    }
  },
  computed: {
    ...mapState('timeTable', ['teachings', 'slots']),
    ...mapState({
      lessons(state) {
        return state['lesson'].lessons
      },
    }),
  },
  methods: {
    ...mapActions('timeTable', ['fetchTeachings', 'fetchClassSchedule', 'createSlot', 'updateSlot', 'removeSlot']),
    ...mapActions('classTimeTable', ['updateLesson']),
    ...mapActions('lesson', ['fetchLessons']),

    async save() {
      try {
        this.$loading.active = true
        const { schedule, scheduleType, endDate } = this.$refs['time-table'].getConfigData()
        let dataToSave = { classId: this.classData.id, scheduleType, schedule, endDate }
        if (this.lessons.length) {
          dataToSave = { ...dataToSave }
        }
        await this.updateLesson({ ...dataToSave })
        this.$alert.success('Cập nhật thời khóa biểu thành công')
        this.$emit('refresh')
        this.dialog = false
        this.cancel()
      } catch (error) {
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.reset()
      this.$refs['time-table'].reset()
      this.isEnable = false
      this.dialog = false
    },
    openDialog(){
      this.dialog = true
    },
    async onFilterChanged() {
      this.searchClass = true
      this.$loading.active = true
      this.isEnable = true
      this.$loading.active = false
    },
    getIndex(index) {
      return index < 7 ? index - 1 : index - 2
    },
    reset() {
      this.searchClass = false
      this.classData = null
    },
    onResize() {
      this.windowHeight = window.innerHeight
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  filters: {
    getTeacher(teacher) {
      if (teacher) {
        const nameArr = teacher.name.split(' ')
        const name = nameArr[nameArr.length - 1]
        if (teacher.gender === 'female') return `C.${name}`
        if (teacher.gender === 'male') return `T.${name}`
        return name
      }
      return null
    },
    getTooltipContent(teaching) {
      if (teaching.teacher && teaching.teacher.name) {
        let prefix = 'GV. '
        if (teaching.teacher.gender === 'female') prefix = 'Cô '
        if (teaching.teacher.gender === 'male') prefix = 'Thầy '
        return get(teaching, 'subjectGroup.title') + ' - ' + prefix + teaching.teacher.name
      } else {
        return get(teaching, 'subjectGroup.title')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
body {
  padding: 40px 90px;
  line-height: 1.5;
}
.section {
  margin-top: 30px;
  margin-bottom: 50px;
}
.drag {
  box-sizing: border-box;
  display: inline-block;
  // border-radius: 4px;
  width: 70px;
  height: 70px;
  background: #f1f1f1;
  position: relative;
  text-align: center;
  cursor: move;
}
.drop {
  box-sizing: border-box;
  display: inline-block;
  width: 100%;
  height: 60px;
  position: relative;
  text-align: center;
  border-radius: 0px;
  z-index: 1;
}

/* time table */
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  white-space: nowrap;
  border: 1px solid #ddd;
}
.daySection {
  height: 61px;
}
.removeButton {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  z-index: 2;
}
.subjectGroup-name {
  font-weight: 500;
}
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
